import {Component} from 'react';

export default class ScrollToTopOnMount extends Component {
    componentDidMount() {
        setTimeout(() => {
            window.scrollTo(0, 0);
        }, 0);
    }

    render() {
        return null
    }
}


// WEBPACK FOOTER //
// ./src/components/ScrollToTopOnMount.js